import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useActiveProperty } from "@/context/ActivePropertyContext";
import { propColor } from "@/lib/propertyColors";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Building2 } from "lucide-react";

// Global property switcher shown in the top header. Only renders when the user
// has 2+ properties. The chosen property is remembered app-wide via context.
export default function PropertySwitcher() {
  const { activePropertyId, setActivePropertyId } = useActiveProperty();
  const [props, setProps] = useState([]);

  useEffect(() => {
    api.get("/properties").then((r) => setProps(r.data || [])).catch(() => {});
  }, []);

  if (props.length < 2) return null;
  const current = props.find((p) => p.id === activePropertyId);

  return (
    <Select value={activePropertyId || "all"} onValueChange={(v) => setActivePropertyId(v === "all" ? "" : v)}>
      <SelectTrigger className="h-9 w-auto min-w-[11rem] gap-2 border-border" data-testid="global-property-switcher">
        <span className="flex items-center gap-2">
          {current
            ? <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: propColor(current) }} />
            : <Building2 className="h-4 w-4 text-muted-foreground" />}
          <SelectValue placeholder="All Properties" />
        </span>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="switch-property-all">
          <span className="inline-flex items-center gap-2"><Building2 className="h-4 w-4" /> All Properties</span>
        </SelectItem>
        {props.map((p) => (
          <SelectItem key={p.id} value={p.id} data-testid={`switch-property-${p.id}`}>
            <span className="inline-flex items-center gap-2">
              <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: propColor(p) }} />
              {p.name}{p.archived && <span className="text-xs text-muted-foreground">(Archived)</span>}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
